import { BaseHTMLAttributes, DetailedHTMLProps } from 'react';

import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

export type Adg4SkeletonProps = {
	width: string | number;
	height: string | number;
	/**
	 * Applied as a data-attribute. Use this to target groups of skeletons with the same name (e.g. for applying custom styles)
	 * ```
	 * groupName="my-skeleton" -> <div data-my-skeleton>
	 * ```
	 */
	groupName?: string;
	testId?: string;
} & DetailedHTMLProps<BaseHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Adg4Skeleton = ({ width, height, groupName, testId, ...props }: Adg4SkeletonProps) => {
	return (
		<Skeleton
			width={width}
			height={height}
			groupName={groupName}
			testId={testId}
			isShimmering
			borderRadius={token('space.100')}
			color={wacToken('color.neutral.light200')}
			ShimmeringEndColor={wacToken('color.neutral.light300')}
			{...props}
		/>
	);
};
